import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";
import {Menu, MenuButton, MenuList} from "@chakra-ui/react";
import useWindowDimensions from "../utils/dimensions";
import NavLink from "./nav_link";
import DesktopFeedSortMenu, {DesktopFeedTopSortMenu} from "./desktop_feed_sort_menu";
import capitalize from "../utils/capitalization";
import {useLoggedIn, useModal} from "../store";
import Signup from "./signup";
import {isPseudoCommunity} from "../store/communites";
import {ChevronDown} from "lucide-react";
import {TopSortMenu} from "./sort_menu";

const Feed = styled.div``;
const SortContainer = styled.div``;
const Sort = styled.div``;
const CurrentSort = styled.div``;
const TopSort = styled.div``;

const LONG_TIMEFRAME_MAPPING = {
    hour: 'Hourly',
    day: 'Daily',
    week: 'Weekly',
    month: 'Monthly',
    all: 'All-time',
}

const PseudoFeeds = styled(({className, sort, timeFrame, community}) => {

    const loggedIn = useLoggedIn();
    const {width} = useWindowDimensions();
    const currentTab = location.pathname.startsWith("/c/trending") ? 'Trending' : (location.pathname.startsWith("/c/all") ? 'All' : loggedIn ? 'Home' : 'Trending');

    const modal = useModal();
    const handleGuestHome = async () => {
        // show prompt to sign up
        modal.open(Signup);
    }

    const isPseudo = isPseudoCommunity(community);

    return (
        <div className={className} style={{padding: isPseudo ? '0' : '0 12px', marginTop: isPseudo || width < 780 ? 0 : '0px',
        fontSize: isPseudo ? '15px' : '14px', marginBottom: width < 780 ? "0" : (isPseudo ? '12px' : '12px')}}>
            {isPseudo &&
            <>
                {
                    loggedIn ?
                        <NavLink href={'/'} react_route active={currentTab === "Home"}>
                            <Feed>
                                Home
                            </Feed>
                        </NavLink>
                        :
                        <Feed onClick={handleGuestHome}>Home</Feed>
                }
                <NavLink href={'/c/trending'} react_route active={currentTab === "Trending"}>
                    <Feed>
                        Trending
                    </Feed>
                </NavLink>
                <NavLink href={'/c/all'} react_route active={currentTab === "All"}>
                    <Feed>
                        All
                    </Feed>
                </NavLink>
            </>
            }
            {width >= 780 &&
            <SortContainer style={{marginLeft: isPseudo ? "auto" : "initial"}}>
                <Menu>
                    <MenuButton>
                        <Sort style={{fontWeight: isPseudo ? 400 : 500}}>
                            Sort by {capitalize(sort)}
                            <ChevronDown size={18} />
                        </Sort>
                    </MenuButton>
                    <MenuList>
                        <DesktopFeedSortMenu community={community} sort={sort}/>
                    </MenuList>
                </Menu>
                {sort === 'top' &&
                    <TopSort>
                        <Menu>
                            <MenuButton>
                                <Sort>
                                    {LONG_TIMEFRAME_MAPPING[timeFrame]}
                                    <ChevronDown size={18} />
                                </Sort>
                            </MenuButton>
                            <MenuList>
                                <DesktopFeedTopSortMenu community={community} sort={sort} timeFrame={timeFrame} />
                            </MenuList>
                        </Menu>
                    </TopSort>
                }
            </SortContainer>
            }
        </div>
    )
})`
  display: flex;
  
  ${Feed} {
    cursor: pointer;
    padding: 6px 16px;
    border-radius: 48px;
    margin-right: 6px;
    color: ${({theme}) => theme.color.name === "dark" ? themecolors.dark_high_impact_text : 'rgb(89,96,104)'};
  }

  .active ${Feed} {
    background-color: ${({theme}) => theme.color.name === "dark" ? themecolors.dark_background_5 : '#fff'};
  }

  ${Sort} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
  }

  ${CurrentSort} {
    padding-left: 6px;
  }

  ${Sort} svg {
    margin-left: 4px;
  }

  ${SortContainer} {
    display: flex;
    align-items: center;
  }
  ${TopSort} {
    margin-left: 16px;
  }

  @media only screen and (max-width: 780px) {
    & {
      margin-bottom: 0;
      padding: 12px 12px 8px 12px;
      background-color: ${({theme}) => theme.color.name === 'dark' ? '#1a1a1b' : '#fff'};
    }

    ${Feed} {
      background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : '#eaeaea'};
      color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};

    }

    .active ${Feed} {
      background-color: ${({theme}) => theme.color.name === 'dark' ? 'white' : 'black'};
      color: ${({theme}) => theme.color.name === 'dark' ? 'black' : '#fff'};
    }
  }
`;

export default PseudoFeeds;
